<template>
  <div class="bgColor card-wrapper cust_mrg">
    <div v-if="featureLoading" class="card-spinner-container">
      <VProgressRing connotation="cta" />
    </div>

    <div v-else-if="products.length > 0">
      <div class="column gap10P heading-border">
        <span class="customer-info-title">Capabilities</span>
        <span class="title">
          Turn on capabilities that you want to use with the application.
          You can add and remove capabilities any time.
        </span>
      </div>

      <div class="feature-card-container sectionPadding">
        <div
          class="feature-card-wrapper"
          v-for="(card, index) in products"
          :key="index"
        >
          <FeatureCard
            :title="card.name"
            :description="card.description"
            v-model:enabled="card.enabled"
            :readonly="!isEditing"
            @update:enabled="(v) => emitUpdate(index, v)"
          />
        </div>
      </div>
      <div v-if="capabilitiesError" class="error-text sectionPadding">
        {{ capabilitiesError }}
        </div>
    </div>

    <div v-else class="no-data-text">No capabilities found.</div>
  </div>
</template>

<script>
import FeatureCard from "./FeatureCard.vue";
export default {
  name: "CapabilitiesSection",
  components: { FeatureCard },
  props: {
    products: { type: Array, required: true },
    featureLoading: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    capabilitiesError: { type: String, default: "" },
  },

  emits: ["updateCapabilities"],

  methods: {
    emitUpdate(index, enabled) {
      this.$emit("updateCapabilities", { index, enabled });
    },
  },
};
</script>
<style lang="scss" scoped>
.card-wrapper {
  border-radius: 8px;
}
.card-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
}
.heading-border {
  border-bottom: 1px solid var(--background-primary);
  padding: 20px;
}
.error-text {
  color: red;
  padding-top: 0px;
  font-size: 13px;
}

.no-data-text {
  text-align: center;
  padding: 20px;
  color: #888;
  font-size: 14px;
}
.feature-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: stretch;
  justify-content: space-between; /* default */
}

/* card styling */
.feature-card-wrapper {
  flex: 1 1 calc(33.333% - 20px);
  min-width: 280px;
  display: flex;
}

@media (max-width: 768px) {
  .feature-card-wrapper {
    flex: 1 1 100%;
  }
}


</style>